<div class="flex py-3">
  <div class="flex-1">
    <h1 class="text-3xl font-semibold">Commission Agent</h1>
    <p class="text-lg text-gray-600">
      Process the commission for the agent associated with this subscription. Please confirm that
      you want to process the commission, as this action will mark the commission as paid and record
      the payment date. Once you click "Confirm Commission", the agent's commission status will be
      updated, and they will receive a notification about the payment.
      <span class="font-bold"></span>
    </p>
  </div>
  <div class="flex">
    <button
      pButton
      class=""
      icon="pi pi-times"
      class="p-button-rounded p-button-danger mt-2 p-button-text"
      (click)="closeDialog()"
    ></button>
  </div>
</div>

<share-form
  #commissionFormRef
  [formFields]="commissionForm"
  [formSubmitAction]="{
    label: 'Confirm Commission',
    icon: 'pi pi-check',
    styleClass: 'p-button-success',
    enabled: true
  }"
  (formSubmitted)="processAgentCommission($event)"
></share-form>
